import React, { useState } from "react";
import IController from "@components/forms/IController";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Config } from "@config/config";
import ISelect from "@components/forms/ISelect";
import { date_now, dateFrEn } from "@global/actions";
import DateInput from "@components/forms/DateInput";
import { createOrUpdatePromotion } from "../Actions";

import dayjs from "dayjs";
import { useModal } from "@components/ModalContext";
const FormPromotion = (props) => {
   const {  closeModal } = useModal();
  const [loading, setLoading] = useState(false);
  const config = new Config(props.t);
  const [selectedPromoType, setSelectedPromoType] = useState(
    config.typePromotionOptions()[0]
  );
  var titleaction = "add";
  var date1 = date_now();
  var date2 = date_now();
  var date3 = dayjs().format("DD/MM/YYYY HH:mm");
  var date4 = dayjs().format("DD/MM/YYYY HH:mm");
  if (props?.promo) {
    date1 = props?.promo.from_at;
    date2 = props?.promo.to_at;
    date3 = props?.promo.from_date_at;
    date4 = props?.promo.to_date_at;
    titleaction = "edit";
  }

  const [fromAt, setFromAt] = useState(date1);
  const [toAt, setToAt] = useState(date2);
  const [fromDateAt, setFromDateAt] = useState(date3);
  const [toDateAt, setToDateAt] = useState(date4);

  const onChangeDate = (from, to) => {
    setFromAt(from);
    setToAt(to);
  };

  const onChangeTwoDate = (from, to) => {
    setFromDateAt(from);
    setToDateAt(to);
  };
  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      name: props?.promo?.name,
      from_at: fromAt,
      to_at: toAt,
      from_date_at: fromDateAt,
      to_date_at: toDateAt,
      type: selectedPromoType?.value,
      cost: props?.promo?.cost,
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    data.from_at = dateFrEn(fromAt);
    data.to_at = dateFrEn(toAt);
    data.from_date_at = dateFrEn(fromDateAt);
    data.to_date_at = dateFrEn(toDateAt);
    data.type = selectedPromoType?.value;
    await createOrUpdatePromotion(props.id, data, props?.promo?.id);
    props.loadData();
    setLoading(false);
    closeModal();  // Added to close the modal after successful submission
  };

  const ruleName = {
    type: "text",
    placeholder: props.t("name"),
    messageError: props.t("name_is__required"),
    className: "input-blue text-dark w-100 p-3 border fw-light ",
    size: "md",
    rules: {
      required: props.t("mandatory"),
    },
  };
  const ruleNumber = {
    type: "number",
    placeholder: props.t("cost"),
    messageError: props.t("cost_is__required"),
    className: "input-blue text-dark w-100 p-3 border fw-light ",
    size: "md",
    rules: {
      required: props.t("mandatory"),
    },
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Row>
        <Col md="12" style={{ marginBottom: "12px" }}>
          <label
            style={{
              display: "block",
              fontSize: "12px",
              fontWeight: "500",
              marginBottom: 5,
            }}
          >
            {props.t("name")}
          </label>
          <IController
            elment="name"
            item={ruleName}
            control={control}
            errors={errors}
            register={register}
          />
        </Col>
        <Col md="6" style={{ marginBottom: "12px" }}>
          <label
            style={{
              display: "block",
              fontSize: "12px",
              fontWeight: "500",
              marginBottom: 5,
            }}
          >
            {props.t("cost")}
          </label>
          <IController
            elment="cost"
            item={ruleNumber}
            control={control}
            errors={errors}
            register={register}
          />
        </Col>
        <Col md="6" style={{ marginBottom: "12px" }}>
          <label
            style={{
              display: "block",
              fontSize: "12px",
              fontWeight: "500",
              marginBottom: 5,
            }}
          >
            {props.t("type")}
          </label>
          <ISelect
            id="type"
            name="type"
            label={props.t("type")}
            value={selectedPromoType}
            handleChange={setSelectedPromoType}
            data={config.typePromotionOptions()}
            isSearchable={false}
            isClearable={false}
          />
        </Col>
        <Col md="12" className="mt-3">
          <label
            style={{
              display: "block",
              fontSize: "12px",
              fontWeight: "500",
              marginBottom: 5,
            }}
          >
            {props.t("booking date")}
          </label>
          <DateInput
            leftLabel={props.t("from")}
            rightLabel={props.t("to")}
            onDateChange={onChangeDate}
            dateFrom={fromAt}
            dateTo={toAt}
          />
        </Col>
        <Col md="12" className="mt-3">
          <label
            style={{
              display: "block",
              fontSize: "12px",
              fontWeight: "500",
              marginBottom: 5,
            }}
          >
            {props.t("start date of the promotion")}
          </label>
          <DateInput
            leftLabel={props.t("from")}
            rightLabel={props.t("to")}
            onDateChange={onChangeTwoDate}
            dateFrom={fromDateAt}
            dateTo={toDateAt}
            showTime={true}
          />
        </Col>
        <Col md="12" className="mt-3">
          <Form
            as="button"
            type="submit"
            className="btn-blue p-3 rounded-3 fw-bold w-100"
          >
            {loading ? (
              <Form
                as="span"
                className="spinner-border spinner-border-sm m-1 "
              ></Form>
            ) : (
              props.t(titleaction)
            )}
          </Form>
        </Col>
      </Row>
    </Form>
  );
};

export default FormPromotion;
